import React, { useState } from 'react';
import './RatingForm.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://makok.alwafierp.com/api';

const RatingForm = () => {
  const [formData, setFormData] = useState({
    number: '',
    favoriteDish: '',
    notes: '',
    ratings: {
      service: '',
      atmosphere: '',
      recommendation: '',
      foodQuality: ''
    }
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  const ratingOptions = ['ممتاز', 'جيد', 'سيء'];
  const ratingCategories = [
    { key: 'service', label: 'خدمة' },
    { key: 'atmosphere', label: 'أجواء المكان' },
    { key: 'recommendation', label: 'تنصح بزيارة المكان' },
    { key: 'foodQuality', label: 'جودة الطعام' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRatingChange = (category, rating) => {
    setFormData(prev => ({
      ...prev,
      ratings: {
        ...prev.ratings,
        [category]: rating
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    setFieldErrors({});

    // التحقق من الحقول المطلوبة
    if (!formData.number || formData.number.trim() === '') {
      setFieldErrors({ number: 'رقم الموبايل إجباري' });
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/ratings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        // معالجة أخطاء التحقق من الخادم
        if (data.errors) {
          setFieldErrors(data.errors);
          const firstError = Object.values(data.errors)[0][0] || data.message || 'حدث خطأ أثناء إرسال التقييم';
          setError(firstError);
        } else {
          setError(data.message || 'حدث خطأ أثناء إرسال التقييم');
        }
        setLoading(false);
        return;
      }

      setSuccess(true);
      setError(null);
      
      // إعادة تعيين النموذج
      setFormData({
        number: '',
        favoriteDish: '',
        notes: '',
        ratings: {
          service: '',
          atmosphere: '',
          recommendation: '',
          foodQuality: ''
        }
      });

      // إخفاء رسالة النجاح تلقائياً بعد 5 ثوان
      setTimeout(() => {
        setSuccess(false);
      }, 5000);
    } catch (err) {
      setError(err.message || 'حدث خطأ أثناء إرسال التقييم. يرجى المحاولة مرة أخرى.');
      setSuccess(false);
      console.error('Error submitting rating:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rating-form-container">
      {/* Success Popup */}
      {success && (
        <div className="popup-overlay" onClick={() => setSuccess(false)}>
          <div className="popup-message success-popup" onClick={(e) => e.stopPropagation()}>
            <div className="popup-icon success-icon">✓</div>
            <div className="popup-content">
              <h3>شكراً لك!</h3>
              <p>تم إرسال تقييمك بنجاح.</p>
            </div>
            <button className="popup-close" onClick={() => setSuccess(false)}>×</button>
          </div>
        </div>
      )}

      {/* Error Popup */}
      {error && (
        <div className="popup-overlay" onClick={() => setError(null)}>
          <div className="popup-message error-popup" onClick={(e) => e.stopPropagation()}>
            <div className="popup-icon error-icon">✗</div>
            <div className="popup-content">
              <h3>حدث خطأ!</h3>
              <p>{error}</p>
            </div>
            <button className="popup-close" onClick={() => setError(null)}>×</button>
          </div>
        </div>
      )}

      <div className="rating-form">
        {/* Header Section */}
        <div className="form-header">
          <div className="header-text">
            <h2 className="welcome-text">مشاركتكم لرأيكم تنبي لنا الكثير</h2>
            <p className="sub-text">فأخبرونا عين أن ويصنع لنا الفرق ونحن سعيدين بخدمتكم دائماً</p>
          </div>
        </div>

        {/* Logo Circle */}
        <div className="logo-circle">
          <div className="circle-content">
            <img src="/logo-white.png" alt="Logo" className="logo-image" />
          </div>
        </div>

        <form onSubmit={handleSubmit} className="form-content">
          {/* Input Fields */}
          <div className="input-section">
            <div className="input-group">
              <label htmlFor="number">الرقم: <span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                id="number"
                name="number"
                value={formData.number}
                onChange={handleInputChange}
                placeholder="أدخل رقم الموبايل"
                className={`form-input ${fieldErrors.number ? 'error' : ''}`}
                required
              />
              {fieldErrors.number && (
                <span style={{ color: 'red', fontSize: '14px', display: 'block', marginTop: '5px' }}>
                  {fieldErrors.number}
                </span>
              )}
            </div>

            <div className="input-group">
              <label htmlFor="favoriteDish">الطبق الذي أعجبك:</label>
              <input
                type="text"
                id="favoriteDish"
                name="favoriteDish"
                value={formData.favoriteDish}
                onChange={handleInputChange}
                placeholder="أدخل اسم الطبق"
                className="form-input"
              />
            </div>

            <div className="input-group">
              <label htmlFor="notes">ملاحظات:</label>
              <textarea
                id="notes"
                name="notes"
                value={formData.notes}
                onChange={handleInputChange}
                placeholder="أدخل ملاحظاتك هنا..."
                className="form-textarea"
                rows="4"
              />
            </div>
          </div>

          {/* Rating Grid */}
          <div className="rating-section">
            <h3 className="rating-title">تقييم الخدمات</h3>
            <div className="rating-grid">
              {/* Column Headers - التقييمات في الأعلى */}
              <div className="grid-header-row">
                <div className="grid-cell header-cell row-header">لوغر المعلم</div>
                {ratingOptions.map((option) => (
                  <div key={option} className="grid-cell header-cell">
                    {option}
                  </div>
                ))}
              </div>

              {/* Rating Rows - الخدمات في الجانب */}
              {ratingCategories.map((category) => (
                <div key={category.key} className="grid-row">
                  <div className="grid-cell row-label">{category.label}</div>
                  {ratingOptions.map((option, colIndex) => (
                    <div key={colIndex} className="grid-cell rating-cell">
                      <input
                        type="radio"
                        name={category.key}
                        id={`${category.key}-${colIndex}`}
                        value={option}
                        checked={formData.ratings[category.key] === option}
                        onChange={() => handleRatingChange(category.key, option)}
                        className="rating-radio"
                      />
                      <label
                        htmlFor={`${category.key}-${colIndex}`}
                        className={`rating-label ${
                          formData.ratings[category.key] === option ? 'selected' : ''
                        }`}
                      >
                      </label>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* Submit Button */}
          <div className="submit-section">
            <button type="submit" className="submit-button" disabled={loading}>
              <span>{loading ? 'جاري الإرسال...' : 'إرسال التقييم'}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RatingForm;

